export default "/images/specimen.png?719e65f35d58c5458463956ccceea80c";